module.exports = __webpack_public_path__ + "img/userEducationalStages.14ea86c3.svg";